(ns common.schema.entities.counterparty-diligence.templates.demo.board-member
  (:require
   [common.schema.entities.counterparty-diligence.templates.questions.board-member :as board-member-q]
   [common.schema.entities.counterparty-diligence.templates.questions.person :as person-q]
   [potpuri.core :as p]))

(def schema
  {:template/schema
   (merge
    (->> [person-q/first-name
          person-q/last-name
          board-member-q/role
          person-q/date-of-birth
          person-q/nationality
          person-q/type-of-identification-attachment
          person-q/identification-expiration-date]
         (p/index-by :field))

    {(:field person-q/passport-photo-page-file)
     (merge
      person-q/passport-photo-page-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/passport)))})}

    {(:field person-q/id-card-front-file)
     (merge
      person-q/id-card-front-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})}

    {(:field person-q/id-card-back-file)
     (merge
      person-q/id-card-back-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})})

   :template/sections
   {:basic-information
    {:ord   0
     :title {:en "Basic information"}
     :fields (->> [person-q/first-name
                   person-q/last-name
                   board-member-q/role
                   person-q/date-of-birth
                   person-q/nationality]
                  (mapv :field))}

    :identification
    {:ord 1
     :title {:en "Identification"}
     :fields (->> [person-q/type-of-identification-attachment
                   person-q/identification-expiration-date
                   person-q/passport-photo-page-file
                   person-q/id-card-front-file
                   person-q/id-card-back-file]
                  (mapv :field))}}})
